module.exports = __webpack_public_path__ + "img/js-logo.90f89df8.png";